module.exports = __webpack_public_path__ + "static/media/click.0d5bab66.mp3";